import { Box, styled } from '@mui/material';

export const VariationTemplateContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: row;
  padding: 0 !important;
`;

export const VariationTemplateSideMenuContainer = styled(Box)`
  position: relative;
  width: 400px;
  padding-right: 20px;
  padding-bottom: 40px;
  overflow: auto;
`;

export const SideMenuHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
`;

export const VariationTemplateContentContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
  border-left: 1px solid ${theme.palette.secondary.light};
  overflow: auto;
  justify-content: space-between;
`,
);

export const VariationTemplatePreviewContainer = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: auto;
`;

export const VariationTemplatePreviewWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VariationTemplatePreviewPlaceholder = styled('img')`
  width: min(70%, 520px);
  height: auto;
  max-height: 60%;
  object-fit: contain;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
`;
